import { useMutation } from "@tanstack/react-query";
import { requestApi } from "@/shared/utills";

const ENDPOINTS = {
  TRANSCRIBE_AUDIO: "/audio/transcriptions",
  STRUCTURIZE_TEXT: "/audio/structurize",
};

export const useTranscribeAudio = () => {
  return useMutation({
    mutationFn: async ({ audioBlob, assessmentId }: { audioBlob: Blob; assessmentId: number }): Promise<string> => {
      const formData = new FormData();
      formData.append("file", audioBlob, "recording.webm");
      formData.append("model", "whisper-1");
      formData.append("language", "ru");
      formData.append("temperature", "0");
      formData.append("prompt", "Employee review, feedback, communication skills, structuring, topic mastery");
      formData.append("assessment_id", assessmentId.toString());

      const response = await requestApi<{ text: string }>({
        method: "POST",
        path: ENDPOINTS.TRANSCRIBE_AUDIO,
        body: formData,
      });

      return response.text;
    },
  });
};

export const useStructurizeText = () => {
  return useMutation({
    mutationFn: async (data: string): Promise<string> => {
      const response = await requestApi<{ structured_text: string }>({
        method: "POST",
        path: ENDPOINTS.STRUCTURIZE_TEXT,
        body: { text: data },
      });
      return response.structured_text;
    },
  });
};
